import { render } from "./criteria-start-page.vue?vue&type=template&id=3da28677&scoped=true&ts=true"
import script from "./criteria-start-page.vue?vue&type=script&lang=ts"
export * from "./criteria-start-page.vue?vue&type=script&lang=ts"

import "./criteria-start-page.vue?vue&type=style&index=0&id=3da28677&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da28677"]])

export default __exports__